import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';
import { useDispatch } from 'react-redux';
import { productsSettingsActions } from '@/Pages/Settings/modules/ProductsSettings/services/reducer';

export function useProductSettings() {
  const dispatch = useDispatch();

  const {
    tours: {
      ProductSettings: { PageTour, CategoryTour },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: PageTour.Title,
      steps: [
        {
          content: PageTour.Step1.Text,
          placement: 'auto',
          target: '#productSettingsTitle',
          title: PageTour.Step1.Title,
          disableBeacon: true,
          link: PageTour.Step1.DetailsLink,
        },
        {
          content: PageTour.Step2.Text,
          placement: 'auto',
          target: '#categoryList',
          title: PageTour.Step2.Title,
          disableBeacon: true,
          link: PageTour.Step2.DetailsLink,
        },
        {
          content: PageTour.Step3.Text,
          placement: 'auto',
          target: '#categoryItem',
          title: PageTour.Step3.Title,
          disableBeacon: true,
          link: PageTour.Step3.DetailsLink,
          styles: {
            spotlight: {
              maxWidth: '800px',
              marginLeft: '20px',
              maxHeight: '35px',
            },
          },
        },
        {
          content: PageTour.Step4.Text,
          placement: 'auto',
          target: '#addNewCategory',
          title: PageTour.Step4.Title,
          disableBeacon: true,
          link: PageTour.Step4.DetailsLink,
        },
        {
          content: PageTour.Step5.Text,
          placement: 'auto',
          target: '#addItemButton',
          title: PageTour.Step5.Title,
          disableBeacon: true,
          link: PageTour.Step5.DetailsLink,
        },
        {
          content: PageTour.Step6.Text,
          placement: 'auto',
          target: '#crudExtended',
          title: PageTour.Step6.Title,
          disableBeacon: true,
          link: PageTour.Step6.DetailsLink,
        },
      ],
    }),
    [PageTour],
  );

  const categoryTour = useMemo<TourType>(
    () => ({
      id: 'categoryTour',
      title: CategoryTour.Title,
      before: () => {
        dispatch(productsSettingsActions.setCategoryModal({ visible: true }));
      },
      steps: [
        {
          content: CategoryTour.Step1.Text,
          placement: 'auto',
          target: '#categoryTitle',
          title: CategoryTour.Step1.Title,
          disableBeacon: true,
          link: CategoryTour.Step1.DetailsLink,
        },
        {
          content: CategoryTour.Step2.Text,
          placement: 'auto',
          target: '#categoryName',
          title: CategoryTour.Step2.Title,
          disableBeacon: true,
          link: CategoryTour.Step2.DetailsLink,
        },
        {
          content: CategoryTour.Step3.Text,
          placement: 'auto',
          target: '#categoryLogo',
          title: CategoryTour.Step3.Title,
          disableBeacon: true,
          link: CategoryTour.Step3.DetailsLink,
        },
        {
          content: CategoryTour.Step4.Text,
          placement: 'auto',
          target: '#buttonsWrapper',
          title: CategoryTour.Step4.Title,
          disableBeacon: true,
          link: CategoryTour.Step4.DetailsLink,
        },
      ],
    }),
    [CategoryTour],
  );

  return [pageTour, categoryTour];
}
